import { Close, PhotoCamera } from '@mui/icons-material';
import { Grid, IconButton, useTheme } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';

export default function ImageUpload({ name, placeholder, limit }) {
    const {
        errors,
        setFieldTouched,
        touched,
        setFieldValue,
        setFieldError,
        values,
    } = useFormikContext();
    const theme = useTheme();

    const [imgArray, setImgArray] = useState(values[name]);

    useEffect(() => {
        name && setFieldValue(name, imgArray);
        placeholder && (imgArray[0] = placeholder);
    }, [imgArray, name, placeholder, setFieldValue]);

    const deleteImageUpload = (item) => {
        const newArray = [...imgArray];

        newArray.filter((val) => {
            return val?.name !== item.name;
        });

        setImgArray(
            newArray.filter((val) => {
                return val.name !== item.name;
            })
        );
    };

    // console.log(theme);

    return (
        <div
            style={{
                border: `1.8px solid ${theme.palette.divider}`,
                borderRadius: theme.shape.borderRadius,
            }}
        >
            <Grid container>
                {imgArray.length < (limit ? limit : placeholder ? 2 : 4) && (
                    <Grid
                        item
                        xs={4}
                        className="d-flex align-items-center justify-content-center p-1"
                        style={{
                            height: 100,
                        }}
                    >
                        <div
                            className="h-100 w-100 d-flex align-items-center justify-content-center"
                            style={{
                                backgroundColor:
                                    theme.palette.mode === 'dark'
                                        ? theme.palette.background.paper
                                        : '#ddd',
                                borderRadius: theme.shape.borderRadius,
                            }}
                        >
                            <input
                                name="photo"
                                accept="image/*"
                                className="d-none"
                                id="upload-photo"
                                type="file"
                                onBlur={() => name && setFieldTouched(name)}
                                onChange={() => {
                                    const path =
                                        document.querySelector(
                                            '#upload-photo'
                                        ).value;
                                    const filetype = path
                                        .substring(path.lastIndexOf('.') + 1)
                                        .toLowerCase();

                                    if (
                                        filetype === 'jpg' ||
                                        filetype === 'png' ||
                                        filetype === 'jpeg'
                                    ) {
                                        setImgArray([
                                            ...imgArray,
                                            document.querySelector(
                                                '#upload-photo'
                                            ).files[0],
                                        ]);
                                    } else {
                                        setFieldError(
                                            name,
                                            'Invalid file type'
                                        );
                                    }
                                }}
                            />
                            <label htmlFor="upload-photo">
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    component="span"
                                >
                                    <PhotoCamera />
                                </IconButton>
                            </label>
                        </div>
                    </Grid>
                )}

                {name &&
                    values[name]?.map((item) => {
                        const isUrl = item.toString().search('http') === 0;

                        return (
                            <Grid
                                item
                                xs={4}
                                key={`${Math.random() * 1000}`}
                                className="d-flex align-items-center justify-content-center p-1"
                                style={{
                                    height: 100,
                                }}
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center h-100 w-100"
                                    style={{
                                        backgroundImage: `url("${
                                            isUrl
                                                ? placeholder
                                                : window?.URL?.createObjectURL(
                                                      item
                                                  )
                                        }")`,

                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                        backgroundColor: 'rgba(0,0,0,.5)',
                                        backgroundBlendMode: 'soft-light',
                                        borderRadius: theme.shape.borderRadius,
                                    }}
                                >
                                    {!isUrl && (
                                        <IconButton
                                            onClick={() => {
                                                deleteImageUpload(item);
                                            }}
                                            style={{
                                                backgroundColor:
                                                    theme.palette.primary.main,
                                                color: theme.palette.text
                                                    .primary,
                                            }}
                                        >
                                            <Close />
                                        </IconButton>
                                    )}
                                </div>
                            </Grid>
                        );
                    })}
            </Grid>

            {/* {imgArray.length < (limit ? limit : placeholder ? 2 : 4) && (
                <div style={{ position: 'relative' }}>
                   
                   
                </div>
            )} */}

            {name && touched[name] && errors[name] && (
                <small
                    className="mb-2 mx-2"
                    style={{ color: theme.palette.error.main }}
                >
                    {errors[name]}
                </small>
            )}
        </div>
    );
}
